import { TaxBreakDown } from '../../shared/models/taxbreakdown.model';
export class Item {
    isTaxInclusive: boolean;
    lineNumber: number;
    tax: number;
    productId: number;
    id: number;
    shoppingCartId: number;
    applicablePrice: number;
    CV: number;
    retailPrice: number;
    wholesalePrice: number;
    paidprice: number;
    itemNumber: string;
    quantity: number;
    isKit: boolean;
    weight: number;
    width: number;
    height: number;
    length: number;
    isVirtualItem: boolean;
    isLiterature: boolean;
    slug: string;
    shortDescription: string;
    name: string;
    displayName: string;
    shoppingCartUrl: string;
    iconUrl: string;
    shippingRequired: boolean;
    measurementUnitLengthValue: number;
    measurementUnitMassValue: number;
    disableDecrement: boolean;
    downloadableProduct: boolean;
    totalPoints: number;
    totalPrice: number;
    taxBreakDown: TaxBreakDown;
    enableAutoship: boolean;
    stockAvailable?: boolean;
    manageStock?: boolean;
    stockQuantity?: number;
    backOrderAllowed?: boolean;
    categoryImageUrl: string;
    catalogPrice: number;
    baseRetailPrice: number;
    baseWholesalePrice: number;
    computedTaxInclusivePrice: number;
    literature: boolean;

    calculateTotalPoints(): number {
        return (this.CV * this.quantity);
    }

    calculateTotalPrice(applicablePrice: number, quantity: number): number {
        return (applicablePrice * quantity);
    }
}
